var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaypalFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.353,
    height: 24,
    viewBox: "0 0 90.353 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Paypal",
    transform: "translate(-936 -1387.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3792",
    "data-name": "Pfad 3792",
    d: "M7.076,21.337H2.47a.641.641,0,0,1-.633-.74L4.944.9A1.068,1.068,0,0,1,6,0h7.46c2.57,0,4.578.543,5.69,1.81A4.767,4.767,0,0,1,20.16,6.1c-.023.143-.047.288-.077.437-.983,5.05-4.349,6.8-8.647,6.8H9.246a1.064,1.064,0,0,0-1.05.9l-1.12,7.106ZM21.222,6.917a3.35,3.35,0,0,0-.607-.541c-.013.076-.026.175-.041.254-.93,4.778-4,7.2-9.138,7.2H9.246a.563.563,0,0,0-.556.479L7.5,21.837H7l-.24,1.516A.56.56,0,0,0,7.311,24h3.882a.933.933,0,0,0,.922-.788c.06-.26.76-4.852.816-5.09a.932.932,0,0,1,.923-.788h.58c3.76,0,6.7-1.528,7.565-5.946.36-1.847.174-3.388-.777-4.471Z",
    transform: "translate(934.171 1387.99)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "PayPal-2",
    "data-name": "PayPal",
    transform: "translate(929.33 1387)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3793",
    "data-name": "Pfad 3793",
    d: "M43.023,6.749H38.251a.663.663,0,0,0-.655.56l-1.93,12.239a.4.4,0,0,0,.394.459h2.279a.663.663,0,0,0,.655-.56l.521-3.3a.662.662,0,0,1,.655-.56h1.511c3.144,0,4.959-1.521,5.432-4.536A3.676,3.676,0,0,0,46.5,7.968,4.428,4.428,0,0,0,43.023,6.749Zm.551,4.47c-.261,1.713-1.57,1.713-2.835,1.713h-.72l.505-3.2a.4.4,0,0,1,.393-.336h.33c.862,0,1.675,0,2.1.491A1.591,1.591,0,0,1,43.574,11.219Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3794",
    "data-name": "Pfad 3794",
    d: "M61.974,12.982H59.689a.4.4,0,0,0-.393.336l-.1.639-.16-.232a3.253,3.253,0,0,0-2.7-.958,5.256,5.256,0,0,0-5.1,4.6,4.314,4.314,0,0,0,.851,3.511,3.576,3.576,0,0,0,2.879,1.163,4.373,4.373,0,0,0,3.164-1.309l-.1.635a.4.4,0,0,0,.392.461h2.059a.663.663,0,0,0,.655-.56l1.235-7.823A.4.4,0,0,0,61.974,12.982ZM58.788,17.43a2.547,2.547,0,0,1-2.579,2.182,1.771,1.771,0,0,1-1.893-2.222,2.558,2.558,0,0,1,2.561-2.2,1.928,1.928,0,0,1,1.524.623A1.978,1.978,0,0,1,58.788,17.43Z",
    transform: "translate(-4.684 -1.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3795",
    "data-name": "Pfad 3795",
    d: "M79.486,13.075h-2.3a.666.666,0,0,0-.549.291l-3.168,4.666L72.13,13.548a.665.665,0,0,0-.636-.473H69.236a.4.4,0,0,0-.378.526l2.53,7.424L69.01,24.383a.4.4,0,0,0,.325.628h2.294a.662.662,0,0,0,.545-.285L79.813,13.7A.4.4,0,0,0,79.486,13.075Z",
    transform: "translate(-10.023 -1.911)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3796",
    "data-name": "Pfad 3796",
    d: "M91.8,6.749H87.031a.663.663,0,0,0-.655.56l-1.93,12.239a.4.4,0,0,0,.392.459h2.45a.464.464,0,0,0,.458-.392l.548-3.469a.662.662,0,0,1,.655-.56h1.51c3.145,0,4.959-1.521,5.433-4.536a3.674,3.674,0,0,0-.609-3.081A4.424,4.424,0,0,0,91.8,6.749Zm.551,4.47c-.26,1.713-1.569,1.713-2.835,1.713H88.8l.506-3.2A.4.4,0,0,1,89.7,9.4h.33c.861,0,1.675,0,2.1.491A1.591,1.591,0,0,1,92.355,11.219Z",
    transform: "translate(-14.737 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3797",
    "data-name": "Pfad 3797",
    d: "M110.756,12.982h-2.284a.4.4,0,0,0-.392.336l-.1.639-.161-.232a3.252,3.252,0,0,0-2.7-.958,5.255,5.255,0,0,0-5.1,4.6,4.316,4.316,0,0,0,.851,3.511,3.578,3.578,0,0,0,2.879,1.163,4.373,4.373,0,0,0,3.164-1.309l-.1.635a.4.4,0,0,0,.394.461h2.058a.663.663,0,0,0,.655-.56l1.236-7.823A.4.4,0,0,0,110.756,12.982ZM107.57,17.43a2.546,2.546,0,0,1-2.579,2.182,1.771,1.771,0,0,1-1.893-2.222,2.559,2.559,0,0,1,2.561-2.2,1.928,1.928,0,0,1,1.524.623A1.968,1.968,0,0,1,107.57,17.43Z",
    transform: "translate(-19.422 -1.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_3798",
    "data-name": "Pfad 3798",
    d: "M118.445,7.084l-1.959,12.463a.4.4,0,0,0,.392.459h1.969a.662.662,0,0,0,.655-.56l1.932-12.238a.4.4,0,0,0-.392-.46h-2.205A.4.4,0,0,0,118.445,7.084Z",
    transform: "translate(-24.417)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalFooter);
export default __webpack_public_path__ + "static/media/paypal_footer.2a98156586f530a4a9314390907eba79.svg";
export { ForwardRef as ReactComponent };